var body = $('body');

$(function () {
    'use strict';
    gallery();
    pagination();
    randomize_quote();
    randomize_sign();
    randomize_post_card_images();
});

var post_card_images = [
    "https://i.insertcred.it/assets/cards/asuka-2.jpg",
    "https://i.insertcred.it/assets/cards/doom64-2.jpg",
    "https://i.insertcred.it/assets/cards/mother3-2.jpg",
    "https://i.insertcred.it/assets/cards/rawdanger-2.jpg",
    "https://i.insertcred.it/assets/cards/outrun2-2.jpg",
    "https://i.insertcred.it/assets/cards/bonk-mouth-2.jpg",
]

var quote_data = [
    "now bear my arctic blast!",
    "I like girls, but now, it's about justice",
    "I have to stay alive and write this article before I die. ok.",
    "big apple, 3 AM",
    "the most gorgeous situation",
    "do I have to go back to the hell again",
    "you can stay here and do filing",
    "home, disappointment, and counterattack",
    "mankind has always been the poison",
    "let's be sad",
    "hustler's complex",
    "my body is ready",
    "it is far a future on PLANET",
    "c'est super efficace!",
    "because video games!!! motherfucker!!!!!!!!!",
    "you will see this dog before you die",
    "take the gun from the traveler",
    "scars of the divine wing",
    "march of the righteous",
    "KOF real fight with relation shoes",
    "saturday's morning is morning salad",
    "dancing in phantasmic hell",
    "tears of sylph",
    "beauty is a sin! oh god!!",
    "growing strong and healthy...minmo!",
    "the bad times are just times that are bad",
    "hassy - always the best",
    "don't underestimate the power of dolphin.",
    "until your next task, rest your soul.",
    "the capital was destroyed, but hey, what can you do?",
    "crush the old order and create a new society!",
    "the omens are good"
]

var sign_data = [
    "https://i.insertcred.it/assets/signs/PCRyl0IY.png",
    "https://i.insertcred.it/assets/signs/TsRFX39b.png",
    "https://i.insertcred.it/assets/signs/KnOO6jv3.png",
    "https://i.insertcred.it/assets/signs/NYVmTvx3.png"
]

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');

    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });
}

function pagination() {
    'use strict';
    var wrapper = $('.post-feed');
    var button = $('.infinite-scroll-button');

    if (body.hasClass('paged-next')) {
        wrapper.on('request.infiniteScroll', function (event, path) {
            button.hide();
        });
        
        wrapper.on('load.infiniteScroll', function (event, response, path) {
            if ($(response).find('body').hasClass('paged-next')) {
                button.show();
            }
        });

        wrapper.on('append.infiniteScroll', function (event, path) {
            randomize_post_card_images();
        });

        wrapper.infiniteScroll({
            append: '.post-card',
            button: '.infinite-scroll-button',
            debug: false,
            hideNav: '.pagination',
            history: false,
            path: '.pagination .older-posts',
            scrollThreshold: false,
            status: '.infinite-scroll-status',
        });
    }
}

function randomize_quote() {
    var quote = $('.site-header-tagline');
    if (quote.length) {
        //console.log("quote exists")
        var new_quote = quote_data[quote_data.length * Math.random() | 0]
        //console.log("quote exists, changing to new_quote: ", new_quote)
        quote.text(new_quote);
        quote.css({ 
            "opacity": 0.5, 
        });
    }
}

function randomize_sign()
{
    $('.site-header-corner-art > img').attr('src', sign_data[sign_data.length * Math.random() | 0]);
}

function get_random_int(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

function randomize_post_card_images() {
    $('.randomize-post-card').each(function(index) {
        if ($(this).hasClass( "randomized" )) {
            //console.log("skipping post-card "+index)
            return
        } else {
            var new_src = post_card_images[post_card_images.length * Math.random() | 0]
            //console.log("new_src "+index+" is ", new_src)
            $(this).children('img').attr('src', new_src);
            $(this).children('img').css({ 
                "object-fit": "cover", 
                "object-position": get_random_int(100)+"% "+get_random_int(100)+"%"
            })
            $(this).addClass("randomized")
        }
    })
}